/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.156.0
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { CodeStatusDerStellungnahme } from '../models';
// @ts-ignore
import { CodeVormerkung } from '../models';
// @ts-ignore
import { ErrorRest } from '../models';
// @ts-ignore
import { PageStellungnahmeUebersichtRest } from '../models';
// @ts-ignore
import { StellungnahmeDetailRest } from '../models';
// @ts-ignore
import { StellungnahmeVormerkungRest } from '../models';
/**
 * StellungnahmeResourceApi - axios parameter creator
 * @export
 */
export const StellungnahmeResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Metadaten einer Stellungnahme ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
         * @summary Endpunkt für Metadaten einer Stellungnahme.
         * @param {string} planID planID vom Verfahren
         * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStellungnahmeDetail: async (planID: string, stellungnahmeID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getStellungnahmeDetail', 'planID', planID)
            // verify required parameter 'stellungnahmeID' is not null or undefined
            assertParamExists('getStellungnahmeDetail', 'stellungnahmeID', stellungnahmeID)
            const localVarPath = `/verfahren/{planID}/stellungnahmen/{stellungnahmeID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"stellungnahmeID"}}`, encodeURIComponent(String(stellungnahmeID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Stellungnahmen, die einem Verfahren zugeordnet sind ausgeliefert.<br> Es wird eine Untermenge der Metadaten der Stellungnahmen ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
         * @summary Endpunkt zum Ausliefern aller Stellungnahmen eines Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} [vts] Verfahrensteilschritt
         * @param {number} [durchgang] Durchgang des Verfahrensteilschrittes
         * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
         * @param {boolean} [hatVormerkung] Ob eine Vormerkung existiert
         * @param {Array<CodeStatusDerStellungnahme>} [codeStatus] Status der Stellungnahme
         * @param {Array<string>} [datum] Datum der Stellungnahme
         * @param {Array<string>} [prioritaet] Priorität der Stellungnahme
         * @param {Array<string>} [verfasser] Verfasser der Stellungnahme (Organisationsname, Vorname und Nachname des Verfassers)
         * @param {Array<string>} [titelOderId] Titel oder ID der Stellungnahme
         * @param {Array<string>} [akteur] Typ des Verfassers (Privatperson true/false)
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetStellungnahmenUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStellungnahmenUebersicht: async (planID: string, vts?: string, durchgang?: number, codeVormerkung?: Array<CodeVormerkung>, hatVormerkung?: boolean, codeStatus?: Array<CodeStatusDerStellungnahme>, datum?: Array<string>, prioritaet?: Array<string>, verfasser?: Array<string>, titelOderId?: Array<string>, akteur?: Array<string>, page?: number, size?: number, sort?: Array<GetStellungnahmenUebersichtSort>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getStellungnahmenUebersicht', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/stellungnahmen`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (vts !== undefined) {
                localVarQueryParameter['vts'] = vts;
            }

            if (durchgang !== undefined) {
                localVarQueryParameter['durchgang'] = durchgang;
            }

            if (codeVormerkung) {
                localVarQueryParameter['codeVormerkung'] = codeVormerkung;
            }

            if (hatVormerkung !== undefined) {
                localVarQueryParameter['hatVormerkung'] = hatVormerkung;
            }

            if (codeStatus) {
                localVarQueryParameter['codeStatus'] = codeStatus;
            }

            if (datum) {
                localVarQueryParameter['datum'] = datum;
            }

            if (prioritaet) {
                localVarQueryParameter['prioritaet'] = prioritaet;
            }

            if (verfasser) {
                localVarQueryParameter['verfasser'] = verfasser;
            }

            if (titelOderId) {
                localVarQueryParameter['titelOderId'] = titelOderId;
            }

            if (akteur) {
                localVarQueryParameter['akteur'] = akteur;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine vorhandene Vormerkung von einer Stellungnahme entfernt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen einer Vormerkung von einer Stellungnahme.
         * @param {string} planID planID vom Verfahren
         * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
         * @param {string} codeVormerkung die zu löschende Vormerkung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loescheStellungnahmeVormerkung: async (planID: string, stellungnahmeID: string, codeVormerkung: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('loescheStellungnahmeVormerkung', 'planID', planID)
            // verify required parameter 'stellungnahmeID' is not null or undefined
            assertParamExists('loescheStellungnahmeVormerkung', 'stellungnahmeID', stellungnahmeID)
            // verify required parameter 'codeVormerkung' is not null or undefined
            assertParamExists('loescheStellungnahmeVormerkung', 'codeVormerkung', codeVormerkung)
            const localVarPath = `/verfahren/{planID}/stellungnahmen/{stellungnahmeID}/vormerken/{codeVormerkung}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"stellungnahmeID"}}`, encodeURIComponent(String(stellungnahmeID)))
                .replace(`{${"codeVormerkung"}}`, encodeURIComponent(String(codeVormerkung)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Vormerkung an mehreren Stellungnahmen gesetzt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
         * @summary Endpunkt zum Setzen einer Vormerkung an mehreren Stellungnahmen.
         * @param {StellungnahmeVormerkungRest} stellungnahmeVormerkungRest Liste der ID von den Stellungnahmen und die Vormerkung
         * @param {string} planID planID vom Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStellungnahmeVormerkung: async (stellungnahmeVormerkungRest: StellungnahmeVormerkungRest, planID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stellungnahmeVormerkungRest' is not null or undefined
            assertParamExists('setStellungnahmeVormerkung', 'stellungnahmeVormerkungRest', stellungnahmeVormerkungRest)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('setStellungnahmeVormerkung', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/stellungnahmen/vormerken`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stellungnahmeVormerkungRest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StellungnahmeResourceApi - functional programming interface
 * @export
 */
export const StellungnahmeResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StellungnahmeResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Metadaten einer Stellungnahme ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
         * @summary Endpunkt für Metadaten einer Stellungnahme.
         * @param {string} planID planID vom Verfahren
         * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStellungnahmeDetail(planID: string, stellungnahmeID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StellungnahmeDetailRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStellungnahmeDetail(planID, stellungnahmeID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StellungnahmeResourceApi.getStellungnahmeDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Stellungnahmen, die einem Verfahren zugeordnet sind ausgeliefert.<br> Es wird eine Untermenge der Metadaten der Stellungnahmen ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
         * @summary Endpunkt zum Ausliefern aller Stellungnahmen eines Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} [vts] Verfahrensteilschritt
         * @param {number} [durchgang] Durchgang des Verfahrensteilschrittes
         * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
         * @param {boolean} [hatVormerkung] Ob eine Vormerkung existiert
         * @param {Array<CodeStatusDerStellungnahme>} [codeStatus] Status der Stellungnahme
         * @param {Array<string>} [datum] Datum der Stellungnahme
         * @param {Array<string>} [prioritaet] Priorität der Stellungnahme
         * @param {Array<string>} [verfasser] Verfasser der Stellungnahme (Organisationsname, Vorname und Nachname des Verfassers)
         * @param {Array<string>} [titelOderId] Titel oder ID der Stellungnahme
         * @param {Array<string>} [akteur] Typ des Verfassers (Privatperson true/false)
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetStellungnahmenUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStellungnahmenUebersicht(planID: string, vts?: string, durchgang?: number, codeVormerkung?: Array<CodeVormerkung>, hatVormerkung?: boolean, codeStatus?: Array<CodeStatusDerStellungnahme>, datum?: Array<string>, prioritaet?: Array<string>, verfasser?: Array<string>, titelOderId?: Array<string>, akteur?: Array<string>, page?: number, size?: number, sort?: Array<GetStellungnahmenUebersichtSort>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageStellungnahmeUebersichtRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStellungnahmenUebersicht(planID, vts, durchgang, codeVormerkung, hatVormerkung, codeStatus, datum, prioritaet, verfasser, titelOderId, akteur, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StellungnahmeResourceApi.getStellungnahmenUebersicht']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine vorhandene Vormerkung von einer Stellungnahme entfernt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen einer Vormerkung von einer Stellungnahme.
         * @param {string} planID planID vom Verfahren
         * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
         * @param {string} codeVormerkung die zu löschende Vormerkung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loescheStellungnahmeVormerkung(planID: string, stellungnahmeID: string, codeVormerkung: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StellungnahmeDetailRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loescheStellungnahmeVormerkung(planID, stellungnahmeID, codeVormerkung, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StellungnahmeResourceApi.loescheStellungnahmeVormerkung']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Vormerkung an mehreren Stellungnahmen gesetzt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
         * @summary Endpunkt zum Setzen einer Vormerkung an mehreren Stellungnahmen.
         * @param {StellungnahmeVormerkungRest} stellungnahmeVormerkungRest Liste der ID von den Stellungnahmen und die Vormerkung
         * @param {string} planID planID vom Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStellungnahmeVormerkung(stellungnahmeVormerkungRest: StellungnahmeVormerkungRest, planID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StellungnahmeDetailRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStellungnahmeVormerkung(stellungnahmeVormerkungRest, planID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StellungnahmeResourceApi.setStellungnahmeVormerkung']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StellungnahmeResourceApi - factory interface
 * @export
 */
export const StellungnahmeResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StellungnahmeResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Metadaten einer Stellungnahme ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
         * @summary Endpunkt für Metadaten einer Stellungnahme.
         * @param {string} planID planID vom Verfahren
         * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStellungnahmeDetail(planID: string, stellungnahmeID: string, options?: any): AxiosPromise<StellungnahmeDetailRest> {
            return localVarFp.getStellungnahmeDetail(planID, stellungnahmeID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Stellungnahmen, die einem Verfahren zugeordnet sind ausgeliefert.<br> Es wird eine Untermenge der Metadaten der Stellungnahmen ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
         * @summary Endpunkt zum Ausliefern aller Stellungnahmen eines Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} [vts] Verfahrensteilschritt
         * @param {number} [durchgang] Durchgang des Verfahrensteilschrittes
         * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
         * @param {boolean} [hatVormerkung] Ob eine Vormerkung existiert
         * @param {Array<CodeStatusDerStellungnahme>} [codeStatus] Status der Stellungnahme
         * @param {Array<string>} [datum] Datum der Stellungnahme
         * @param {Array<string>} [prioritaet] Priorität der Stellungnahme
         * @param {Array<string>} [verfasser] Verfasser der Stellungnahme (Organisationsname, Vorname und Nachname des Verfassers)
         * @param {Array<string>} [titelOderId] Titel oder ID der Stellungnahme
         * @param {Array<string>} [akteur] Typ des Verfassers (Privatperson true/false)
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetStellungnahmenUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStellungnahmenUebersicht(planID: string, vts?: string, durchgang?: number, codeVormerkung?: Array<CodeVormerkung>, hatVormerkung?: boolean, codeStatus?: Array<CodeStatusDerStellungnahme>, datum?: Array<string>, prioritaet?: Array<string>, verfasser?: Array<string>, titelOderId?: Array<string>, akteur?: Array<string>, page?: number, size?: number, sort?: Array<GetStellungnahmenUebersichtSort>, options?: any): AxiosPromise<PageStellungnahmeUebersichtRest> {
            return localVarFp.getStellungnahmenUebersicht(planID, vts, durchgang, codeVormerkung, hatVormerkung, codeStatus, datum, prioritaet, verfasser, titelOderId, akteur, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine vorhandene Vormerkung von einer Stellungnahme entfernt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen einer Vormerkung von einer Stellungnahme.
         * @param {string} planID planID vom Verfahren
         * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
         * @param {string} codeVormerkung die zu löschende Vormerkung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loescheStellungnahmeVormerkung(planID: string, stellungnahmeID: string, codeVormerkung: string, options?: any): AxiosPromise<StellungnahmeDetailRest> {
            return localVarFp.loescheStellungnahmeVormerkung(planID, stellungnahmeID, codeVormerkung, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Vormerkung an mehreren Stellungnahmen gesetzt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
         * @summary Endpunkt zum Setzen einer Vormerkung an mehreren Stellungnahmen.
         * @param {StellungnahmeVormerkungRest} stellungnahmeVormerkungRest Liste der ID von den Stellungnahmen und die Vormerkung
         * @param {string} planID planID vom Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStellungnahmeVormerkung(stellungnahmeVormerkungRest: StellungnahmeVormerkungRest, planID: string, options?: any): AxiosPromise<Array<StellungnahmeDetailRest>> {
            return localVarFp.setStellungnahmeVormerkung(stellungnahmeVormerkungRest, planID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StellungnahmeResourceApi - object-oriented interface
 * @export
 * @class StellungnahmeResourceApi
 * @extends {BaseAPI}
 */
export class StellungnahmeResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Metadaten einer Stellungnahme ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
     * @summary Endpunkt für Metadaten einer Stellungnahme.
     * @param {string} planID planID vom Verfahren
     * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StellungnahmeResourceApi
     */
    public getStellungnahmeDetail(planID: string, stellungnahmeID: string, options?: RawAxiosRequestConfig) {
        return StellungnahmeResourceApiFp(this.configuration).getStellungnahmeDetail(planID, stellungnahmeID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Stellungnahmen, die einem Verfahren zugeordnet sind ausgeliefert.<br> Es wird eine Untermenge der Metadaten der Stellungnahmen ausgeliefert.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_READ or EIGENE_STELLUNGNAHME_READ or ADMIN</p>
     * @summary Endpunkt zum Ausliefern aller Stellungnahmen eines Verfahrens.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} [vts] Verfahrensteilschritt
     * @param {number} [durchgang] Durchgang des Verfahrensteilschrittes
     * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
     * @param {boolean} [hatVormerkung] Ob eine Vormerkung existiert
     * @param {Array<CodeStatusDerStellungnahme>} [codeStatus] Status der Stellungnahme
     * @param {Array<string>} [datum] Datum der Stellungnahme
     * @param {Array<string>} [prioritaet] Priorität der Stellungnahme
     * @param {Array<string>} [verfasser] Verfasser der Stellungnahme (Organisationsname, Vorname und Nachname des Verfassers)
     * @param {Array<string>} [titelOderId] Titel oder ID der Stellungnahme
     * @param {Array<string>} [akteur] Typ des Verfassers (Privatperson true/false)
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<GetStellungnahmenUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StellungnahmeResourceApi
     */
    public getStellungnahmenUebersicht(planID: string, vts?: string, durchgang?: number, codeVormerkung?: Array<CodeVormerkung>, hatVormerkung?: boolean, codeStatus?: Array<CodeStatusDerStellungnahme>, datum?: Array<string>, prioritaet?: Array<string>, verfasser?: Array<string>, titelOderId?: Array<string>, akteur?: Array<string>, page?: number, size?: number, sort?: Array<GetStellungnahmenUebersichtSort>, options?: RawAxiosRequestConfig) {
        return StellungnahmeResourceApiFp(this.configuration).getStellungnahmenUebersicht(planID, vts, durchgang, codeVormerkung, hatVormerkung, codeStatus, datum, prioritaet, verfasser, titelOderId, akteur, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine vorhandene Vormerkung von einer Stellungnahme entfernt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
     * @summary Endpunkt zum Löschen einer Vormerkung von einer Stellungnahme.
     * @param {string} planID planID vom Verfahren
     * @param {string} stellungnahmeID stellungnahmeID der Stellungnahme
     * @param {string} codeVormerkung die zu löschende Vormerkung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StellungnahmeResourceApi
     */
    public loescheStellungnahmeVormerkung(planID: string, stellungnahmeID: string, codeVormerkung: string, options?: RawAxiosRequestConfig) {
        return StellungnahmeResourceApiFp(this.configuration).loescheStellungnahmeVormerkung(planID, stellungnahmeID, codeVormerkung, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Vormerkung an mehreren Stellungnahmen gesetzt.</p><p><b>Benötigte Rechte:</b> STELLUNGNAHME_WRITE or EIGENE_STELLUNGNAHME_WRITE or ADMIN</p>
     * @summary Endpunkt zum Setzen einer Vormerkung an mehreren Stellungnahmen.
     * @param {StellungnahmeVormerkungRest} stellungnahmeVormerkungRest Liste der ID von den Stellungnahmen und die Vormerkung
     * @param {string} planID planID vom Verfahren
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StellungnahmeResourceApi
     */
    public setStellungnahmeVormerkung(stellungnahmeVormerkungRest: StellungnahmeVormerkungRest, planID: string, options?: RawAxiosRequestConfig) {
        return StellungnahmeResourceApiFp(this.configuration).setStellungnahmeVormerkung(stellungnahmeVormerkungRest, planID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetStellungnahmenUebersichtSort = {
    akteur: 'akteur',
    akteurasc: 'akteur,asc',
    akteurdesc: 'akteur,desc',
    verfasser: 'verfasser',
    verfasserasc: 'verfasser,asc',
    verfasserdesc: 'verfasser,desc',
    titel: 'titel',
    titelasc: 'titel,asc',
    titeldesc: 'titel,desc',
    datum: 'datum',
    datumasc: 'datum,asc',
    datumdesc: 'datum,desc',
    prioritaet: 'prioritaet',
    prioritaetasc: 'prioritaet,asc',
    prioritaetdesc: 'prioritaet,desc',
    status: 'status',
    statusasc: 'status,asc',
    statusdesc: 'status,desc'
} as const;
export type GetStellungnahmenUebersichtSort = typeof GetStellungnahmenUebersichtSort[keyof typeof GetStellungnahmenUebersichtSort];
